import { Col, InputField, Label, ReactSelectBox } from 'client/CommonComponents';
import { CONSTANTS } from 'client/utils/constants';
import '../Request.scss'
import { REQUEST_CONSTANTS } from '../RequestConstants';

const Reason = (props: any) => {

    const reason = props.reason
    const reasonItem = props.reasonItem;
    const onChangeReasonType = props.onChangeReasonType;   

    return (<>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3 mt-0'>
            <Label required data-attribute="Reason_Default_Label">Reason</Label>
            <ReactSelectBox
                options={reasonItem}
                onChange={(item: any, e: any) => onChangeReasonType(e, item, reason)}
                name='ReasonType'
                value={reason.reasonType == "" ? {label: REQUEST_CONSTANTS.SELECT_REASON_TYPE,text:""}: {label: reason.reasonType, text: reason.reasonType}}
                className= {reason.reasonTypeError ? 'controlValidation' : ''}            
             data-attribute="Reason_ReasonType_SearchSelectBox" />
            {reason.reasonTypeError ? <p className='validMessage'>{reason.reasonTypeError}</p> : null}
        </Col>
        
    </>)
}

export default Reason;
